if (!String.prototype.splice) {
  /**
   * {JSDoc}
   *
   * The splice() method changes the content of a string by removing a range of
   * characters and/or adding new characters.
   *
   * @this {String}
   * @param {number} start Index at which to start changing the string.
   * @param {number} delCount An integer indicating the number of old chars to remove.
   * @param {string} newSubStr The String that is spliced in.
   * @return {string} A new string with the spliced substring.
   */
  String.prototype.splice = function (start, delCount, newSubStr) {  // eslint-disable-line
    return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount))
  }
}

if (!String.prototype.toEnglishDigits) {
  /**
   * {JSDoc}
   *
   * The toEnglishDigits method convert every Persian digits to English in content of a string
   *
   * @this {string}
   * @return {string} Persian digits converted to English chars
   */
  String.prototype.toEnglishDigits = function () {  // eslint-disable-line
    var charCodeZero = '۰'.charCodeAt(0)
    return this.replace(/[۰-۹]/g, function (w) {
      return w.charCodeAt(0) - charCodeZero
    })
  }
}

if (!String.prototype.toPersianDigits) {
  /**
   * {JSDoc}
   *
   * The toPersianDigits method convert every English digits to Persian in content of a string
   *
   * @this {string}
   * @return {string} English digits converted to Persian chars
   */
  String.prototype.toPersianDigits = function () {  // eslint-disable-line
    var charCodeZero = '۰'.charCodeAt(0)
    var charCodeZeroEn = '0'.charCodeAt(0)
    var diff = charCodeZero - charCodeZeroEn
    return this.replace(/[0-9]/g, function (w) {
      return String.fromCharCode(w.charCodeAt(0) + diff)
    })
  }
}

if (!String.prototype.toLocaleDigits) {
  /**
   * {JSDoc}
   *
   * The toPersianDigits method convert every English digits to Persian in content of a string
   *
   * @this {string}
   * @return {string} English digits converted to Persian chars
   */
  String.prototype.toLocaleDigits = function () {  // eslint-disable-line
    return (String(this) !== 'null' && String(this) !== 'undefined') || this === '0' ? this.toPersianDigits() : ''
  }
}

if (!String.prototype.toPriceFormat) {
  /**
   * {JSDoc}
   *
   * The toPriceFormat method split every 3 number with a splitter
   *
   * @this {string}
   * @param {splitter} splitter char
   * @return {string} Formatted string as a price
   */
  String.prototype.toPriceFormat = function (splitter) {  // eslint-disable-line
    if (!splitter) {
      splitter = ','
    }

    return this.replace(/\B(?=(\d{3})+(?!\d))/g, splitter)
  }
}

// export default {}
String.fromKeyCode = function (keyCode) {
  var arr = {
    8: 'Backspace',
    9: 'Tab',
    13: 'Enter',
    16: 'Shift',
    17: 'Ctrl',
    18: 'Alt',
    19: 'Pause/Break',
    20: 'Caps Lock',
    27: 'Esc',
    32: 'Space',
    33: 'Page Up',
    34: 'Page Down',
    35: 'End',
    36: 'Home',
    37: 'Left',
    38: 'Up',
    39: 'Right',
    40: 'Down',
    45: 'Insert',
    46: 'Delete',
    48: '0',
    49: '1',
    50: '2',
    51: '3',
    52: '4',
    53: '5',
    54: '6',
    55: '7',
    56: '8',
    57: '9',
    65: 'A',
    66: 'B',
    67: 'C',
    68: 'D',
    69: 'E',
    70: 'F',
    71: 'G',
    72: 'H',
    73: 'I',
    74: 'J',
    75: 'K',
    76: 'L',
    77: 'M',
    78: 'N',
    79: 'O',
    80: 'P',
    81: 'Q',
    82: 'R',
    83: 'S',
    84: 'T',
    85: 'U',
    86: 'V',
    87: 'W',
    88: 'X',
    89: 'Y',
    90: 'Z',
    91: 'Windows',
    93: 'Right Click',
    96: 'Numpad 0',
    97: 'Numpad 1',
    98: 'Numpad 2',
    99: 'Numpad 3',
    100: 'Numpad 4',
    101: 'Numpad 5',
    102: 'Numpad 6',
    103: 'Numpad 7',
    104: 'Numpad 8',
    105: 'Numpad 9',
    106: 'Numpad *',
    107: 'Numpad +',
    109: 'Numpad -',
    110: 'Numpad .',
    111: 'Numpad /',
    112: 'F1',
    113: 'F2',
    114: 'F3',
    115: 'F4',
    116: 'F5',
    117: 'F6',
    118: 'F7',
    119: 'F8',
    120: 'F9',
    121: 'F10',
    122: 'F11',
    123: 'F12',
    144: 'Num Lock',
    145: 'Scroll Lock',
    182: 'My Computer',
    183: 'My Calculator',
    186: ';',
    187: '=',
    188: ',',
    189: '-',
    190: '.',
    191: '/',
    192: '`',
    219: '[',
    220: '\\',
    221: ']',
    222: '"',
  }

  return arr[keyCode]
}

if (!String.prototype.getWords) {
  /**
   * {JSDoc}
   *
   * The getWords split strings into words separated by spaces
   *
   * @this {string}
   * @return {string[]} string splitted into string[]
   */
  String.prototype.getWords = function () {  // eslint-disable-line
    var str = (this || '').trim()
    var words = str.split(' ')

    words = words.map((item, index) => item.trim()).filter(item => item != null && item !== '')
    return words
  }
}

if (!String.prototype.isDateTime) {
  String.prototype.isDateTime = function () {
    const d = new Date(this || '0001-01-01')
    return d.getFullYear() > 1
  }
}